import { OfferKindEnum } from '../../services/exports/Constants';

export const OFFERS_WITH_PRODUCTS: Readonly<OfferKindEnum[]> = [
  OfferKindEnum.AmountOffByProducts,
  OfferKindEnum.PercentageOffByProducts,
  OfferKindEnum.FreeItemByProducts,
  OfferKindEnum.FreeItemByMinSpendValue,
  OfferKindEnum.Bogo,
  OfferKindEnum.BogoHalfPrice,
];

export const OFFERS_PRODUCTS_KEYS_BY_KIND: Readonly<Partial<Record<OfferKindEnum, string[]>>> = {
  [OfferKindEnum.AmountOffByProducts]: ['products'],
  [OfferKindEnum.PercentageOffByProducts]: ['products'],
  [OfferKindEnum.Bogo]: ['products'],
  [OfferKindEnum.BogoHalfPrice]: ['products'],
  [OfferKindEnum.FreeItemByProducts]: ['products', 'free_products'],
  [OfferKindEnum.FreeItemByMinSpendValue]: ['free_products'],
};
